import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Logo } from "@/components/Logo";

const LINKS = [
  { label: "Hub", href: "/" },
  { label: "AI", href: "/ai" },
  { label: "Factory", href: "/factory" },
  { label: "Stories", href: "/stories" },
  { label: "Careers", href: "/careers" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-2xl bg-white/75 border-b border-black/5" : "bg-transparent"
      }`}
      data-testid="main-nav"
    >
      <div className="relative flex items-center justify-between px-6 sm:px-10 py-5">
        <Logo />
        <nav
          className="hidden md:flex items-center gap-10 absolute left-1/2 -translate-x-1/2"
          data-testid="nav-links"
        >
          {LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-[11px] font-medium uppercase tracking-[0.22em] text-[#474747] hover:text-[#3A3A3C] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a
          href="/#pilot"
          data-testid="nav-order-btn"
          className="rounded-full bg-[#0D0D0E] text-white text-[11px] font-medium uppercase tracking-[0.18em] px-5 py-2.5 hover:bg-[#1B2A4A] transition-colors duration-300"
        >
          Order
        </a>
      </div>
    </motion.header>
  );
};
